function parseLists() {
  const lists = document.querySelectorAll('[class*="list:fa"]');
  lists.forEach((list) => {
    const iconClassName = getFaIcon(list);
    if (iconClassName === "fa") {
      return;
    }
    addIcons(list, iconClassName);
  });
}

function addIcons(list, iconClassName) {
  Array.from(list.children).forEach((child) => {
    child.insertAdjacentHTML("afterbegin", `<i class="${iconClassName}"></i>`);
  });
}

function getFaIcon(list) {
  const listClassName = list.className
    .split(" ")
    .find((className) => className.includes("list:fa"));

  return listClassName.split(":")[1].split("_").join(" ");
}

parseLists();
